import joi from 'joi';
import endpoints from 'constants/endpoints';
import formErrors from 'constants/formErrors';

import { InputsEnum, TextInputTypes } from 'types/dynamicInputs';

export default {
  ubication: {
    value: {
      name: '',
      address: {
        lineOne: '',
        lineTwo: '',
        city: '',
        state: '',
        postalCode: ''
      },
      coordinates: undefined
    },
    label: 'Ubication',
    input: InputsEnum.GOOGLE_MAPS_AUTOCOMPLETE,
    joi: joi
      .object({
        name: joi.string().required().messages({
          'string.empty': formErrors.REQUIRED
        }),
        address: joi
          .object({
            lineOne: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            lineTwo: joi.string().optional().allow(''),
            city: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            state: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            }),
            postalCode: joi.string().required().messages({
              'string.empty': formErrors.REQUIRED
            })
          })
          .required(),
        coordinates: joi
          .object({
            lat: joi.number().required(),
            lng: joi.number().required()
          })
          .optional()
      })
      .required()
      .messages({
        'object.base': formErrors.REQUIRED
      })
  },
  isActive: {
    value: false,
    label: 'Is active',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  },
  venueName: {
    value: '',
    label: 'Name',
    limit: 150,
    input: InputsEnum.INPUT,
    type: TextInputTypes.TEXT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },
  accountId: {
    value: '',
    label: 'Account',
    input: InputsEnum.AUTOCOMPLETE,
    endpoint: endpoints.SEARCH_ACCOUNT,
    type: TextInputTypes.TEXT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },
  timezone: {
    value: '',
    options: [],
    label: 'Timezone',
    input: InputsEnum.SELECT,
    joi: joi.string().required().messages({
      'string.empty': formErrors.REQUIRED
    })
  },
  primaryActivity: {
    value: '',
    label: 'Primary Activity',
    limit: 150,
    input: InputsEnum.INPUT,
    type: TextInputTypes.TEXT,
    joi: joi.string().optional().allow('')
  },
  alcoholCertification: {
    value: false,
    label: 'Alcohol Certificate Required',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  },
  uniformRequired: {
    value: false,
    label: 'Uniform Approval Required',
    input: InputsEnum.CHECK,
    joi: joi.boolean().optional()
  }
};
